import styles from './CasDivider.module.scss';

export interface CasDividerProps {
  vertical?: boolean;
}

export function CasDivider({ vertical }: CasDividerProps) {
  return <div className={vertical ? styles.vertical : styles.horizontal}></div>;
}

export default CasDivider;
